import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";
import TagManager from 'react-gtm-module';

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import App from './App';

Sentry.init({
    dsn: "https://44e79e58d15b42068b7746d4d8c5c515@o1092528.ingest.sentry.io/6125606",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
    beforeSend: (event) => {
        if ((window.location.hostname === 'localhost') || (process.env.REACT_APP_ENVIRONMENT === 'DEV')) {
            return null;
        }
        return event;
    },
});

import { unregister } from "./registerServiceWorker";
if (process.env.REACT_APP_ENVIRONMENT === 'PROD') {
    //console.log('GTM - THIS IS IN PROD')
    const tagManagerArgs = {
        gtmId: 'GTM-WJQJZFB'
    }

    TagManager.initialize(tagManagerArgs)
}
unregister();

ReactDOM.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>,
    document.getElementById("root")
);
